let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f4z1K")).then(() => parcelRequire('4oHVd'));